import React, { Component } from "react";
import Select from "react-select";
import { api_url } from "../globalFunction/global_string";

export class ReactSelectUnitproxyApply extends Component {
  static displayName = ReactSelectUnitproxyApply.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [], // 存放 API 轉換的選項
      selectedOption: props.selectedValue || null, // ✅ 預設選擇的值
      current_user_type: localStorage.getItem("login_user_type"),
      parentName: props.parentName,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectnet !== this.props.selectnet) {
      console.log("🔄 區網變更，重新加載單位列表");
      this.loadData(); // ✅ 當 selectnet 變更時，重新請求 API
    }

    if (prevProps.selectedValue !== this.props.selectedValue) {
      this.setState({
        selectedOption: this.props.selectedValue || null,
      });
    }
  }



  componentDidMount() {
    this.loadData();
  }

  loadData() {
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;
    const formData = new FormData();

    if (parentName === "superS") {
      formData.append("local_net_id", this.props.selectnet);
      formData.append("local_net_name", this.props.local_net_name);
    } else if (parentName === "superM") {
      formData.append("local_net_id", localStorage.getItem("login_user_net_id"));
      formData.append("local_net_name", localStorage.getItem("login_user_net_name"));
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { Authorization: localStorage.getItem("accessToken") },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        let arr_status = [String(data.statusCode), data.row, data.detail];
        console.log(data)

        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        // ✅ 轉換為 react-select 需要的格式
        const formattedOptions = rows.map((option) => ({
          value: option.local_unit_id,
          label: option.local_unit_name,
        }));

        this.setState({ options: formattedOptions });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  handleSelectChange = (selectedOption) => {
    console.log("🔥 選擇的值:", selectedOption);

    this.setState({ selectedOption });

    if (typeof this.props.SelectUnitproxyApply === "function") {
      this.props.SelectUnitproxyApply(
        {
          name: this.props.name,
          value: selectedOption?.value || "",
          selectedName: selectedOption?.label || "",
        },
        this.props.index
      );
    }
  };

  render() {
    return (
      <Select
        id={this.state.id}
        name={this.state.name}
        value={this.state.selectedOption}
        onChange={this.handleSelectChange}
        options={this.state.options}
        placeholder="請選擇單位"
        isClearable
        isSearchable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            maxHeight: "600px", // ✅ 增加最大高度，顯示更多筆數
            overflowY: "auto",
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: "300px", // ✅ 讓下拉選單能顯示更多筆數（例如 56 筆）
          })
        }}
      />

    );
  }
}
